export default "__VITE_ASSET__YLuid_iU__"